








































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import { EventBus } from '@/event-bus';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { ShipmentAddressBook } from '@/models/addressBook/ShipmentAddressBook';
import { SettingsAddressSearchRequest } from '@/models/addressBook/SettingsAddressSearchRequest';
import { SettingsAddressesResponse } from '@/models/addressBook/SettingsAddressesResponse';
import SaveAddressRequest from '@/models/addressBook/SaveAddressRequest';

import exportService from '@/services/ExportService';
import addressService from '@/services/AddressService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      term: '',
      currentAddressId: '',
      loading: false,
      exportLoading: false,
      deleting: false,
      editing: false,
      displayAddressForm: false,
      displayConfirmDelete: false,
      lastSearchId: 0,
      cancelTokenSource: null,
      headers: [
        { text: '', sortable: false, value: 'id' },
        {
          text: 'Vendor Company Name',
          sortable: true,
          value: 'company',
          class: 'address-header',
        },
        {
          text: 'Vendor Contact Name',
          sortable: true,
          value: 'contact',
          class: 'address-header',
        },
        {
          text: 'Vendor Phone Number',
          sortable: true,
          value: 'phone',
          width: '225px',
        },
        {
          text: 'Address Type',
          sortable: true,
          value: 'typeId',
          class: 'addressType-header',
        },
        {
          text: 'Address',
          sortable: true,
          value: 'location',
          class: 'address-header',
        },
        {
          text: 'Vendor Email',
          sortable: true,
          value: 'email',
          class: 'address-header',
        },
      ],
      page: [] as Array<ShipmentAddressBook>,
      addresses: [] as ShipmentAddressBook[],
      snackbar: false,
      snackbarText: '',
    };
  },
  created() {
    this.search();
  },
  methods: {
    pageChange(newPage: number) {
      this.currentPage = newPage;
      this.search();
    },
    edit(id) {
      this.currentAddressId = id;
      this.editing = true;
      addressService
        .getById(id)
        .then((x) => {
          const address = new SaveAddressRequest();
          address.id = x.id.toString();
          address.company = x.company;
          address.address1 = x.address1;
          address.address2 = x.address2;
          address.city = x.city;
          address.state = x.state;
          address.zipCode = x.postalCode;
          address.contact = x.contact;
          address.phone = x.phone;
          address.fax = x.fax;
          address.email = x.email;
          address.locationCode = x.locationCode;
          address.country = x.country;
          address.shared = x.shared;
          address.department = x.department;
          address.extension = x.extension;
          address.specialInstructions = x.specialInstructions;
          address.title = x.title;
          address.typeId = x.typeId;

          this.currentAddressId = null;

          EventBus.$emit('settings-address-book-edit', address);
          this.displayAddressForm = true;
        })
        .finally(() => {
          this.editing = false;
        });
    },
    search() {
      this.loading = true;
      const searchId = ++this.lastSearchId;

      // cancel any in-progress requests
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('New search initiated');
      }

      // create a new cancel token source
      this.cancelTokenSource = axios.CancelToken.source();

      const request = new SettingsAddressSearchRequest(
        this.user.accountId,
        this.user.userId,
        this.term,
        this.currentPage,
        this.pageSize
      );

      addressService
        .searchSettings(request, this.cancelTokenSource.token)
        .then((response: SettingsAddressesResponse) => {
          // only update the UI if this is the result of the latest search request
          if (searchId === this.lastSearchId) {
            if (response && response.data) {
              this.addresses = response.data.items || [];
              this.page = response.data.items || [];
              this.totalCount = response.data.totalCount || 0;
            } else {
              this.addresses = [];
              this.page = [];
              this.totalCount = 0;
              console.error('Response or response.data is undefined');
            }
            this.loading = false;
          }
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.error('Search error:', error);
          }
          // only set loading to false if this is the latest search request
          if (searchId === this.lastSearchId) {
            this.loading = false;
          }
        });
    },
    searchWithReset() {
      this.currentPage = 1;
      this.search();
    },
    onClear() {
      this.term = null;
      this.currentPage = 1;
      this.search();
    },
    exportCsv() {
      if (this.totalCount === 0) {
        this.$toast.show(`No data to export.`);
        return;
      }

      // prevent multiple export operations
      if (this.exportLoading) {
        return;
      }

      this.exportLoading = true;
      this.fetchAllAddresses()
        .then((allAddresses) => {
          if (allAddresses.length === 0) {
            this.$toast.show(`No data to export.`);
          } else {
            exportService.csvDownload(allAddresses, 'Address Book');
            this.$toast.show(
              `Export completed successfully. ${allAddresses.length} records downloaded.`
            );
          }
          this.exportLoading = false;
        })
        .catch((error) => {
          console.error('Export error:', error);
          this.exportLoading = false;
          this.$toast.show(`Export failed. Please try again.`);
        });
    },

    fetchAllAddresses() {
      const exportCancelTokenSource = axios.CancelToken.source();

      // create a request to get all data for current search
      const request = new SettingsAddressSearchRequest(
        this.user.accountId,
        this.user.userId,
        this.term,
        1,
        this.totalCount
      );

      // make an API call to get all data
      return addressService
        .searchSettings(request, exportCancelTokenSource.token)
        .then((response) => {
          if (response && response.data && response.data.items) {
            return response.data.items;
          }
          return [];
        });
    },
    confirmDelete(addressId: string) {
      this.currentAddressId = addressId;
      this.displayConfirmDelete = true;
    },
    openAddNewAddressForm() {
      EventBus.$emit('settings-address-book-create-new');
      this.displayAddressForm = true;
    },
    softDeleteAddress() {
      if (this.currentAddressId) {
        this.deleting = true;
        // find the address to get the company name
        const addressToDelete = this.page.find(
          (address) => address.id.toString() === this.currentAddressId
        );
        const companyName = addressToDelete ? addressToDelete.company : '';

        addressService.deleteById(this.currentAddressId).then(() => {
          // show toast with company name
          this.$toast.show(`Address for ${companyName} has been deleted.`);

          // perform a search to refresh the data
          this.search();

          this.displayConfirmDelete = false;
          this.currentAddressId = null;
          this.deleting = false;
        });
      }
    },
    closeAndReload() {
      this.displayAddressForm = false;
      this.currentPage = 1; // reset to first page when reloading after add/edit
      this.search();
    },
    getTypeDesc(typeId) {
      const types = addressService.getAddressTypes();
      let type = types.find((x) => x.value == typeId);

      if (typeId == 3) return 'Bill To Address';
      if (typeId == 2) return 'BoL Address';

      let text = type?.text;
      if (text == 'Both Origin and Destination Address' || !text) {
        text = 'Orig & Dest';
      }

      return text;
    },
  },
  computed: {
    addEditDialogWidth() {
      if (this.smAndDown) return '90%';
      if (this.xl) return '35%';

      return '45%';
    },
    entryCount() {
      const start = (this.currentPage - 1) * this.pageSize + 1;
      const end = Math.min(this.currentPage * this.pageSize, this.totalCount);
      return `Showing ${start} to ${end} of ${this.totalCount} entries`;
    },
    showNoData() {
      return !this.loading && (!this.page || !this.page.length);
    },
    showDataGrid() {
      return !this.showNoData;
    },
    showPaging() {
      return (
        this.totalCount > 0 && Math.ceil(this.totalCount / this.pageSize) > 1
      );
    },
  },
  beforeDestroy() {
    // cancel any in-progress requests
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Component destroyed');
    }
  },
});
